try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsx, jsxs } from 'react/jsx-runtime';
import { CtaBlock } from '@design-system/cta-block';
import { Icon } from '@design-system/icon';
import { Modal } from '@design-system/modal';
import classNames from 'classnames';
import { forwardRef } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

const Dialog = forwardRef((_a, ref) => {
    var { className, isShowing, close, closeModal, primaryButtonLabel, primaryButtonAriaLabel, secondaryButtonLabel, secondaryButtonAriaLabel, closeIconSize = 'large', onPrimaryButtonClick, mode = 'default', showCloseButton = true, showOverlay = true, showIcon = false, iconType = 'tooltip', titleContent, data } = _a, rest = __rest(_a, ["className", "isShowing", "close", "closeModal", "primaryButtonLabel", "primaryButtonAriaLabel", "secondaryButtonLabel", "secondaryButtonAriaLabel", "closeIconSize", "onPrimaryButtonClick", "mode", "showCloseButton", "showOverlay", "showIcon", "iconType", "titleContent", "data"]);
    const actionButtonData = [];
    if (primaryButtonLabel) {
        actionButtonData.push({
            elementType: 'button',
            variant: 'primary',
            size: 'large',
            children: primaryButtonLabel,
            className: 'cds-dialog-window__button',
            onClick: onPrimaryButtonClick,
            'aria-label': primaryButtonAriaLabel,
        });
    }
    if (secondaryButtonLabel) {
        actionButtonData.push({
            elementType: 'button',
            variant: 'secondary',
            size: 'large',
            onClick: closeModal,
            children: secondaryButtonLabel,
            className: 'cds-dialog-window__button',
            'aria-label': secondaryButtonAriaLabel,
        });
    }
    return (jsx(Modal, Object.assign({ isShowing: isShowing, close: close, className: classNames('cds-dialog-window', className, {
            'cds-dialog-window--inverse-mode': mode !== 'default',
        }), mode: mode, showOverlay: showOverlay, closeModal: closeModal, closeIconSize: closeIconSize, showCloseButton: showCloseButton, topElements: titleContent }, rest, { children: jsxs("div", Object.assign({ className: "cds-dialog-window__content", ref: ref }, { children: [showIcon && (jsx("div", Object.assign({ className: "cds-dialog-window__icon-container" }, { children: jsx(Icon, { size: 32, className: "cds-dialog-window__icon", icon: iconType }) }))), data && jsx("div", Object.assign({ className: "cds-dialog-window__data" }, { children: data })), actionButtonData.length > 0 && (jsx("div", Object.assign({ className: "cds-dialog-window__button-container" }, { children: jsx(CtaBlock, { data: actionButtonData }) })))] })) })));
});

export { Dialog };
